<template>
  <div>
    <wc-data-box
      title='Timesheet Categories'
      :titleIcon='header.icon'
      :titleIconColor='header.color'
      :loading='isLoading'
      showAdd
      @add='addCategory()'
    >
      <v-simple-table v-if='cats.length > 0' dense>
        <thead>
        </thead>
        <tbody>
          <tr v-for='c in orderedCats' :key='c.id' @click='openCategory(c)'>
            <td>{{ c.description }}</td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-card-text v-if='cats.length === 0'>
        No categories created yet.
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      width='300'
      title='Category'
      :icon='header.icon'
      :showDialog='showDialog'
      @cancel='showDialog = false'
      @save='saveCategory()'
      :loadingButtons='saving'
    >
      <v-form v-model='isFormValid' ref='form'>
        <v-text-field
          label='Description'
          v-model='catCopy.description'
          :rules='[rules.required]'
        ></v-text-field>
      </v-form>
    </wc-dialog>

    <wc-confirm
      title='Cannot edit'
      :showDialog='showCannotEdit'
      hideCancel
      saveText='OK'
      saveColor='primary'
      @confirm='showCannotEdit = false'
    >
      This category is required for timesheets to function correctly and therefore cannot be edited.
    </wc-confirm>
  </div>
</template>

<script>
import timesheetsAPI from '@/modules/timesheets/api/timesheets'
import formRules from '@/mixins/formRules'
import miscServices from '@/services/misc'
import _ from 'lodash'

export default {
  name: 'timesheet-categories',
  mixins: [formRules],
  props: {
    division: {
      required: true
    }
  },
  data: () => ({
    isLoading: true,
    showDialog: false,
    isFormValid: false,
    showCannotEdit: false,
    saving: false,
    cats: [],
    catCopy: {
      description: '',
      division: null,
      project_required: false
    }
  }),
  computed: {
    orderedCats () {
      return _.sortBy(this.cats, 'description')
    },
    header () {
      return this.$store.state.icons.modules.timesheets
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.cats = await timesheetsAPI.getTimesheetCategories(this.division.id)
      if (this.cats.length === 0) {
        // If a division does not have any categories yet, we must auto-add
        // one that has the `project_required` field set to true. We do this here.
        this.catCopy.description = 'Specific Project'
        this.catCopy.division = this.division.id
        this.catCopy.project_required = true
        await this.saveCategory()
      }
      this.isLoading = false
    },
    resetCopy () {
      this.catCopy = {}
      this.catCopy.description = ''
      this.catCopy.division = this.division.id
      this.catCopy.project_required = false
    },
    addCategory () {
      this.resetCopy()
      this.openCategory(this.catCopy)
    },
    openCategory (c) {
      if (c.project_required) {
        this.showCannotEdit = true
      } else {
        this.saving = false
        this.catCopy = _.cloneDeep(c)
        this.showDialog = true
        setTimeout(() => {
          this.$refs.form.resetValidation()
        })
      }
    },
    async saveCategory () {
      this.saving = true
      let tmp = null
      if (this.catCopy.id) {
        tmp = await timesheetsAPI.updateTimesheetCategory(this.catCopy)
        this.cats = miscServices.replaceObject(this.cats, tmp)
      } else {
        tmp = await timesheetsAPI.createTimesheetCategory(this.catCopy)
        this.cats.push(tmp)
      }
      this.showDialog = false
      this.saving = false
    }
  }
}
</script>
